import { ReactElement } from 'react';
import { CheckList, CheckListProps } from '../check-list';
import { withNativeProps } from '../utils/native-props';
import './style.less';

export type CheckboxProps = Omit<CheckListProps, 'checkedClassPrefix'> & {
  children?: ReactElement | ReactElement[];
};

export const Checkbox = (props: CheckboxProps) => {
  return withNativeProps(
    props,
    <CheckList {...props} className="v-checkbox" checkedClassPrefix="v-checkbox">
      {props.children}
    </CheckList>,
  );
};
